import React from 'react';
import { useTheme } from '@mui/material';
import { Box } from '../Box';
import { Icon } from '../Icon';

const BreadcrumbChevron: React.FC = () => {
  const theme = useTheme();
  const componentTokens = theme.palette?.componentTokens;

  return (
    <Box mx={2}>
      <Icon
        type="chevron-right"
        color={componentTokens?.breadcrumbs.colors.primary.assets.resting}
        size="medium"
      />
    </Box>
  );
};

export default BreadcrumbChevron;
